export default __webpack_public_path__ + "static/darkLogo-42879c83730deae811b1cce2ac924a7d.svg";